export default __webpack_public_path__ + "static/media/xsushi.68832d6e.svg";